import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ComponentsModule } from '@freelancer/components';
import { DirectivesModule } from '@freelancer/directives';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { PipesModule } from '@freelancer/pipes';
import { UiModule } from '@freelancer/ui';
import { UserProfileStatsModule } from 'app/user-profile/user-profile-stats/user-profile-stats.module';
import { UserProfileSummaryRatingRedesignComponent } from './user-profile-summary-rating-redesign.component';

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    FeatureFlagsModule,
    PipesModule,
    MatTooltipModule,
    UiModule,
    UserProfileStatsModule,
    ComponentsModule,
  ],
  declarations: [UserProfileSummaryRatingRedesignComponent],
  exports: [UserProfileSummaryRatingRedesignComponent],
})
export class UserProfileSummaryRatingRedesignModule {}
